export const C_USDC_DECIMALS = 6;
